import { Link, useNavigate } from "react-router-dom";
import api from "../api"; // your axios instance
import logo from "../assets/logo.jpg"; // local logo

export default function Navbar() {
  const navigate = useNavigate();
  const accessToken = localStorage.getItem("access_token");
  const isAuthenticated = !!accessToken;

  const handleLogout = async () => {
    const refresh_token = localStorage.getItem("refresh_token");
    if (refresh_token) {
      try {
        await api.post("/accounts/logout/", { refresh_token });
      } catch (err) {
        console.error("Failed to logout on backend", err);
      }
    }

    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    navigate("/login");
  };

  return (
    <nav className="bg-white shadow px-6 py-4 flex justify-between items-center">
  {/* Left: Logo */}
  <div className="flex items-center gap-2">
    <img src={logo} alt="Labor Prophet Logo" className="h-10 w-auto" />
    <span className="text-xl font-bold text-gray-800">Living Wage Scraper Dashboard</span>
  </div>

  {/* Right: Navigation + Authentication */}
  <div className="flex items-center gap-4">
    {isAuthenticated && (
      <Link
        to="/cities"
        className="text-gray-800 hover:text-blue-600 font-medium transition-colors"
      >
        Cities
      </Link>
    )}

    {isAuthenticated ? (
      <button
        onClick={handleLogout}
        className="bg-gray-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md transition-colors"
      >
        Logout
      </button>
    ) : (
      <>
        <Link
          to="/login"
          className="text-gray-800 hover:text-blue-600 font-medium transition-colors"
        >
          Login
        </Link>
        <Link
          to="/register"
          className="text-gray-800 hover:text-blue-600 font-medium transition-colors"
        >
          Register
        </Link>
      </>
    )}
  </div>
</nav>
  );
}
